import PageContainer from "../../components/container/PageContainer";
import React, {useEffect, useState} from "react";
import workStatusApi from "../../services/workStatusApi";
import useTable from "../../hooks/useTable";
import Alert from "../../helpers/Alert";
import dashboardApi from "../../services/messageApi";
import Table from "../../components/Table";
import {PaginatedData} from "../../types";
import {useNavigate} from "react-router-dom";
import {useParams} from "react-router";

export default function Message() {
    const params = useParams();

    const [loading, setLoading] = useState(true);
    const [loadingTable, setloadingTable] = useState(false);

    const [menssageState, setMenssageState] = useState([
        {
            description: 'Abertas',
            data_consult: 'abertas',
            quantity: 0,
        },
        {
            description: 'Finalizadas',
            data_consult: 'finalizadas',
            quantity: 0,
        },
        {
            description: 'Em andamento',
            data_consult: 'andamento',
            quantity: 0,
        },
        {
            description: 'Aguardando',
            data_consult: 'aguardando',
            quantity: 0,
        }
    ]);
    const [cardSelected, setCardSelected] = useState(params.tab ? params.tab : 'abertas');
    const [titleTable, setTitleTable] = useState('Mensagens');

    const navigate = useNavigate();
    async function getData() {
        const {data, isError} = await dashboardApi.getDataDashboardQuantity();

        if (!isError){
            const newStatusMessages = [...menssageState]

            newStatusMessages.map((status: any, index: number) => {
                newStatusMessages[index]['quantity'] = data[status.data_consult] === undefined ? 0 : data[status.data_consult]
            })
            setMenssageState(newStatusMessages);
        }
        setLoading(false)
    }

    useEffect(() => {
        getData()
    }, [])

    const { tableProps, loadData } = useTable({
        denyInitialLoad: true,
        dataLoader: async (params) => {
            const { data, isError } = await dashboardApi.getDataDashboard(cardSelected, params);
            if (isError) {
                Alert.error(data.message || data.error || 'Falha ao carregar dados.');
                return;
            }
            return data as any;
        }
    });

    useEffect(() => {
        loadData(cardSelected)
    }, [cardSelected])

    const onClickCard = async (dataConsult: string) => {
        const nameConsult = menssageState.filter((st) => st.data_consult === dataConsult);
        setTitleTable(nameConsult[0]['description'])
        setCardSelected(dataConsult)
    }

    const columns: any = {
        abertas: [
            { label: "Assunto", index: "subject", type: 'string'},
            { label: "Cliente", index: "name", type: 'string'},
            { label: "Tipo", index: "contact_type", type: 'string'},
            { label: "Situação", index: "status", type: 'string'},
            { label: "Aberto em", index: "created_at", type: 'dateT'},
            { label: "Finalizado", index: "finalized_at", type: 'dateT'},
        ],
        finalizadas: [
            { label: "Assunto", index: "subject", type: 'string'},
            { label: "Cliente", index: "name", type: 'string'},
            { label: "Tipo", index: "contact_type", type: 'string'},
            { label: "Situação", index: "status", type: 'string'},
            { label: "Aberto em", index: "created_at", type: 'dateT'},
            { label: "Finalizado", index: "finalized_at", type: 'dateT'},
        ],
        andamento: [
            { label: "Assunto", index: "subject", type: 'string'},
            { label: "Cliente", index: "name", type: 'string'},
            { label: "Tipo", index: "contact_type", type: 'string'},
            { label: "Situação", index: "status", type: 'string'},
            { label: "Aberto em", index: "created_at", type: 'dateT'},
            { label: "Finalizado", index: "finalized_at", type: 'dateT'},
        ],
        aguardando: [
            { label: "Assunto", index: "subject", type: 'string'},
            { label: "Cliente", index: "name", type: 'string'},
            { label: "Tipo", index: "contact_type", type: 'string'},
            { label: "Situação", index: "status", type: 'string'},
            { label: "Aberto em", index: "created_at", type: 'dateT'},
            { label: "Finalizado", index: "finalized_at", type: 'dateT'},
        ],
    }

    const goToMessage = (dataForm: any) => {
        navigate('/mensagem/'+dataForm.id)
    }

    return(
        <PageContainer>
            <div className={'flex flex-wrap gap-5 w-full md:justify-center'}>
                {
                    loading ?
                        <span className="flex items-center justify-center h-7">
                            <svg className="animate-spin -ml-1 mr-3 h-[14px] w-[14px] text-border" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </span>
                        :
                        <div className={'flex flex-col gap-3 w-full'}>
                            <div className={'flex gap-2 flex justify-center'}>
                                {
                                    menssageState.map((menssage) => {
                                        return(
                                            <div onClick={() => onClickCard(menssage.data_consult)} className={`flex bg-[#1C1C24] cursor-pointer flex-col items-center justify-center md:w-[250px] xs:w-full h-[162px] ${menssage.data_consult === cardSelected ? 'border-2 border-border text-system-primary' : ''} hover:border-2 hover:border-border rounded-lg`}>
                                                <div className={'font-semibold text-system-primary text-[36px]'}>
                                                    {menssage.quantity}
                                                </div>
                                                <div className={'font-semibold'}>
                                                    {menssage.description}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div className={'border border-system-gray-gray80 rounded-xl mb-[90px] bg-system-blue-medium'}>
                                <div className={'p-5 text-system-primary text-[20px] font-semibold border-b border-system-gray-gray80'}>
                                    {titleTable}
                                </div>
                                <div className="table_component " role="region">
                                {
                                    loadingTable ?
                                        <span className="flex items-center justify-center h-7">
                                            <svg className="animate-spin -ml-1 mr-3 h-[14px] w-[14px] text-border" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                        </span>
                                        :

                                        <Table
                                            onClick={goToMessage}
                                            {...tableProps}
                                            data={tableProps.data}
                                            columns={columns[cardSelected] || []}
                                        />
                                }

                            </div>
                            </div>
                        </div>

                }
            </div>
        </PageContainer>
    )
}